/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * slider.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Imprt swiper.
 */
import Swiper from "swiper/bundle";

/**
 * Imprt CSS.
 */
import "swiper/css/bundle";

/**
 * 共通スライダー
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
if (document.getElementById('slider')) {

    const option = {
        loop: true,
        slidesPerView: 'auto',
        initialSlide: 0,
        centeredSlides: true,
        spaceBetween: 10,
        preventClicks: true,
        speed: 1500,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        grabCursor: true,
        navigation: {
            prevEl: '.button__prev',
            nextEl: '.button__next',
        },
    };

    const slider = new Swiper("#slider", option);
}


/**
 * その他スライダー読み込み
 *━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import "./slider/thumbnail/slider-thumbnail";
import "./slider/other/other-sliders";